import { type ChangeEvent, type Dispatch, type SetStateAction } from 'react'

import { type TMainCategoryData } from '@App/types/servicesTypes'

import style from './NameTitle.module.scss'

interface IProps {
    isEdit: boolean
    name: string
    editableCategory: TMainCategoryData | null
    setEditableCategory: Dispatch<SetStateAction<TMainCategoryData | null>>
}

export const NameTitle = (props: IProps) => {
    const { name, isEdit, editableCategory, setEditableCategory } = props

    const onChangeHandler = (e: ChangeEvent<HTMLInputElement>) =>
        setEditableCategory((prev) => prev && { ...prev, name: e.target.value })

    const onRenderNameByEditMode = () => {
        if (isEdit && editableCategory) {
            return (
                <div className={style.inputContainer}>
                    <input name='edit-category-name' value={editableCategory.name} onChange={onChangeHandler} />
                </div>
            )
        } else {
            return (
                <div className={style.titleContainer}>
                    <span>{name}</span>
                </div>
            )
        }
    }

    return onRenderNameByEditMode()
}
